module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Rectangle-c2fee945f67218e922849697f7b7d2c5.svg";